import { Component, OnInit } from '@angular/core';
import { QueryService } from '../comun/services/query.service';
import { GlobalConstants } from '../global-constants';
import { By } from '@angular/platform-browser';

@Component({
  selector: 'app-botones-home',
  templateUrl: './botones-home.component.html',
  styleUrl: './botones-home.component.css'
})
export class BotonesHomeComponent implements OnInit {
  busy: boolean = false;
  misdatos: any = {};

  constructor(private query: QueryService) {
    this.busy = true;
  }

  ngOnInit() {
    this.query.query('misdatos', 'GET', null).subscribe((resultado:any) => {
      this.misdatos = resultado;
      this.busy = false;
    });
  }

  goOpcion(opcion: string = 'perfiles') {
    window.location.href = GlobalConstants.urlServer + opcion;
  }

}
